import { UserRepository } from "../../../domain/repositories/user.repository";
import { ChangePasswordUseCase } from "../../../domain/usecases/user/change-password-usecase";
import { DeleteProfilePhotoUseCase } from "../../../domain/usecases/user/delete-profile-photo-usecase";
import { GetProfilePhotoUseCase } from "../../../domain/usecases/user/get-profile-photo-usecase";
import { GetStateTourUseCase } from "../../../domain/usecases/user/get-state-tour.usecase";
import { GetUserProfileUseCase } from "../../../domain/usecases/user/get-user-profile-usecase";
import { LoginUserUseCase } from "../../../domain/usecases/user/login-user-usecase";
import { SendOtpChangePasswordUseCase } from "../../../domain/usecases/user/send-otp-change-password-usecase";
import { SetProfilePhotoUseCase } from "../../../domain/usecases/user/set-profile-photo-usecase";
import { UpdatePersonalInfoProfileUseCase } from "../../../domain/usecases/user/update-personal-info-profile-usecase";
import { ValidateOtpChangePasswordUseCase } from "../../../domain/usecases/user/validate-otp-change-password-usecase";
import { ValidateRecaptchaUseCase } from "../../../domain/usecases/user/validate-recaptcha.usecase";

const loginUseCaseFactory =
(UserRepo: UserRepository) => new LoginUserUseCase(UserRepo);
export const LoginUserUseCaseProvider = {
    provide: LoginUserUseCase,
    useFactory: loginUseCaseFactory,
    deps: [UserRepository],
};
const sendOtpChangePasswordUseCaseFactory =
(UserRepo: UserRepository) => new SendOtpChangePasswordUseCase(UserRepo);
export const SendOtpChangePasswordUseProvider = {
    provide: SendOtpChangePasswordUseCase,
    useFactory: sendOtpChangePasswordUseCaseFactory,
    deps: [UserRepository],
};

const validateOtpChangePasswordUseCaseFactory =
(UserRepo: UserRepository) => new ValidateOtpChangePasswordUseCase(UserRepo);
export const ValidateOtpChangePasswordUseCaseProvider = {
    provide: ValidateOtpChangePasswordUseCase,
    useFactory: validateOtpChangePasswordUseCaseFactory,
    deps: [UserRepository],
};

const validateRecaptchaUseCaseFactory =
(UserRepo: UserRepository) => new ValidateRecaptchaUseCase(UserRepo);
export const ValidateRecaptchaUseCaseProvider = {
    provide: ValidateRecaptchaUseCase,
    useFactory: validateRecaptchaUseCaseFactory,
    deps: [UserRepository],
};

const changePasswordUseCaseFactory =
(UserRepo: UserRepository) => new ChangePasswordUseCase(UserRepo);
export const ChangePasswordUserUseCaseProvider = {
    provide: ChangePasswordUseCase,
    useFactory: changePasswordUseCaseFactory,
    deps: [UserRepository],
};

const getStateTourUseCaseFactory =
(UserRepo: UserRepository) => new GetStateTourUseCase(UserRepo);
export const GetStateTourUseCaseProvider = {
    provide: GetStateTourUseCase,
    useFactory: getStateTourUseCaseFactory,
    deps: [UserRepository],
};

const getUserProfileUseCaseFactory =
(UserRepo: UserRepository) => new GetUserProfileUseCase(UserRepo);
export const GetUserProfileUseCaseProvider = {
    provide: GetUserProfileUseCase,
    useFactory: getUserProfileUseCaseFactory,
    deps: [UserRepository],
};

const updatePersonalInfoProfileUseCaseFactory =
(UserRepo: UserRepository) => new UpdatePersonalInfoProfileUseCase(UserRepo);
export const UpdatePersonalInfoProfileUseCaseProvider = {
    provide: UpdatePersonalInfoProfileUseCase,
    useFactory: updatePersonalInfoProfileUseCaseFactory,
    deps: [UserRepository],
};

const getProfilePhotoUseCaseFactory =
(UserRepo: UserRepository) => new GetProfilePhotoUseCase(UserRepo);
export const GetProfilePhotoUseCaseProvider = {
    provide: GetProfilePhotoUseCase,
    useFactory: getProfilePhotoUseCaseFactory,
    deps: [UserRepository],
};

const setProfilePhotoUseCaseFactory =
(UserRepo: UserRepository) => new SetProfilePhotoUseCase(UserRepo);
export const SetProfilePhotoUseCaseProvider = {
    provide: SetProfilePhotoUseCase,
    useFactory: setProfilePhotoUseCaseFactory,
    deps: [UserRepository],
};

const deleteProfilePhotoUseCaseFactory =
(UserRepo: UserRepository) => new DeleteProfilePhotoUseCase(UserRepo);
export const DeleteProfilePhotoUseCaseProvider = {
    provide: DeleteProfilePhotoUseCase,
    useFactory: deleteProfilePhotoUseCaseFactory,
    deps: [UserRepository],
};
